import { signIn, signInWithEmail, signUpWithEmail } from "../auth.js";

export function renderLanding(root) {
  let devSection = "";
  const isLocal = typeof window !== "undefined" && 
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  if (import.meta.env?.DEV || isLocal) {
    devSection = `
      <div class="emulator-auth-card">
        <h3>Vietējais emulators: Ātrā pieteikšanās</h3>
        <div class="emulator-accounts-grid">
          <button class="emu-account-btn" data-email="karlis.vesters@gmail.com">
            <span class="emu-avatar">👨‍💻</span>
            <div class="emu-details">
              <span class="emu-role">Vecāks (Kārlis)</span>
              <span class="emu-email">karlis.vesters@gmail.com</span>
            </div>
          </button>
          <button class="emu-account-btn" data-email="vecaks2@ro3k.dev">
            <span class="emu-avatar">👩‍👦</span>
            <div class="emu-details">
              <span class="emu-role">Vecāks (Co-parent)</span>
              <span class="emu-email">vecaks2@ro3k.dev</span>
            </div>
          </button>
          <button class="emu-account-btn" data-email="berns1@ro3k.dev">
            <span class="emu-avatar">👦</span>
            <div class="emu-details">
              <span class="emu-role">Bērns 1 (berns1)</span>
              <span class="emu-email">berns1@ro3k.dev</span>
            </div>
          </button>
          <button class="emu-account-btn" data-email="berns2@ro3k.dev">
            <span class="emu-avatar">👧</span>
            <div class="emu-details">
              <span class="emu-role">Bērns 2 (berns2)</span>
              <span class="emu-email">berns2@ro3k.dev</span>
            </div>
          </button>
          <button class="emu-account-btn emu-new-user" data-new-user="true">
            <span class="emu-avatar">✨</span>
            <div class="emu-details">
              <span class="emu-role">Jauns lietotājs</span>
              <span class="emu-email">Rādīs lomu izvēli</span>
            </div>
          </button>
        </div>
        <p id="emu-login-status" class="emu-login-status"></p>
      </div>
    `;
  }

  root.innerHTML = `
    <section class="landing">
      <video class="hero" src="/hero-video.mp4" autoplay muted loop playsinline preload="metadata"></video>
      <h2>Matemātikas treniņi bērniem</h2>
      <p class="lead">Uzlabo bērna matemātikas prasmes ar interesantiem uzdevumiem no 2. līdz 11. klasei.</p>
      <ul class="benefits">
        <li>Pārbaudīti uzdevumi dažādām klašu grupām</li>
        <li>Tūlītējs rezultāts un pašpārbaude</li>
        <li>Detalizēti risinājumi, lai mācītos no kļūdām</li>
      </ul>
      <button id="landing-signin" class="cta">Pieslēgties ar Google</button>
      ${devSection}
    </section>`;

  root.querySelector("#landing-signin").addEventListener("click", () =>
    signIn().catch((err) => alert("Pieteikšanās neizdevās: " + err.message)),
  );

  if (import.meta.env?.DEV || isLocal) {
    const buttons = root.querySelectorAll(".emu-account-btn");
    const statusText = root.querySelector("#emu-login-status");

    buttons.forEach((btn) => {
      btn.addEventListener("click", async () => {
        const email = btn.dataset.newUser
          ? `new-${Date.now()}@ro3k.dev`
          : btn.dataset.email;
        statusText.textContent = `Pieslēdzas kā ${email}...`;
        statusText.className = "emu-login-status emu-loading";
        buttons.forEach((b) => (b.disabled = true));

        try {
          if (btn.dataset.newUser) {
            await signUpWithEmail(email, "password");
          } else {
            await signInWithEmail(email, "password");
          }
        } catch (err) {
          console.error("Emulator auto-login failed:", err);
          statusText.textContent = `Kļūda: ${err.message}`;
          statusText.className = "emu-login-status emu-error";
          buttons.forEach((b) => (b.disabled = false));
        }
      });
    });
  }
}
